import styled from 'styled-components';
import bundleBackground from '../../../images/Oval.svg';
import Panel from '../../UI/Panel/Panel';
import { PanelOverlay } from '../../UI/Panel/styles/PanelStyled';

const ExtraBalancePanel = styled(Panel)`
  & {
    ${PanelOverlay} {
      z-index: 10001;
    }
  }
`;

const ExtraBalanceHeaderBottom = styled.div`
  position: absolute;
  height: 175px;
  width: 100%;
  background-image: url(${bundleBackground});
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
`;

// eslint-disable-next-line import/prefer-default-export
export { ExtraBalancePanel, ExtraBalanceHeaderBottom };
